<template>
	<div class="cassie-vertical-md mb-2">
		<v-row
			v-if="loaded"
			class="flex flex-row"
		>
			<v-col
				cols="3"
				class="d-flex flex-grow-1"
			>
				<DoughnutChartCard
					:chart-data="chartDatas[0]"
					:loading="chartsLoading"
					:error="chartErrors[0]"
					:chart-options="chartOptions"
					:plugins="plugins"
					container-id="cookies"
					title="Cookies"
					class="flex-grow-1"
					@retry="loadScanCharts"
				/>
			</v-col>
			<v-col cols="3">
				<SiteScannerColumn
					:summary="scanReport"
				/>
			</v-col>
			<v-col
				cols="3"
				class="d-flex flex-grow-1"
			>
				<DoughnutChartCard
					:chart-data="chartDatas[1]"
					:loading="chartsLoading"
					:error="chartErrors[1]"
					:chart-options="chartOptions"
					:plugins="plugins"
					container-id="cookies-two"
					title="Trackers"
					class="flex-grow-1"
					@retry="loadScanCharts"
				/>
			</v-col>
			<v-col
				cols="3"
				class="d-flex flex-grow-1"
			>
				<DoughnutChartCard
					:chart-data="chartDatas[2]"
					:loading="chartsLoading"
					:error="chartErrors[2]"
					:chart-options="chartOptions"
					:plugins="plugins"
					container-id="cookies-three"
					title="Resources"
					class="flex-grow-1"
					@retry="loadScanCharts"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import DoughnutChartCard from '../../../../../../../shared/components/doughnut-chart-card.vue'
import {
	getScanSummary,
	getScanChart
} from '../../../../../../../shared/utils/api/site-scanner.js'
import SiteScannerColumn from './site-scanner-column.vue'
import { chartColors } from '../../../../../../../shared/utils/chart-colors.js'
export default {
	components: {
		SiteScannerColumn,
		DoughnutChartCard
	},
	props: {
		scanGuid: String
	},
	data () {
		return {
			loaded: false,
			scanReport: null,
			chartOptions: {
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						display: false
					},
					title: {
						display: false
					}
				}
			},
			chartDatas: [],
			chartErrors: [],
			chartsLoading: true,
			scanCharts: []
		}
	},
	computed: {
		plugins () {
			return [{
				title: {
					display: true,
					text: 'Custom Chart Title'
				}
			}]
		}
	},
	async created () {
		const { data } = await getScanSummary(this.scanGuid)
		this.scanReport = data
		this.$emit('set-scan-name', this.scanReport.currentScan.summary.scanName)
		this.$emit('set-gpc-detected', this.scanReport.currentScan.summary.gpcDetected)
		if (this.scanReport.previousScan) {
			this.$emit('set-scan-caption', {
				currentScanId: this.scanReport.currentScan.summary.scanId,
				previousScanId: this.scanReport.previousScan.summary.scanId
			})
		}
		// Flipped before the charts are fetched, not after. The summary is
		// already in hand by this point, so the row can render and let the
		// three cards show their own loading state. Setting it afterwards meant
		// the cards only appeared once loading had already finished, so the
		// skeleton was unreachable on first load.
		this.loaded = true
		await this.loadScanCharts()
	},
	methods: {
		/**
		 * Fetches the three summary charts, keeping each one's failure to
		 * itself so a single bad request shows one error card rather than
		 * taking the whole tab down.
		 *
		 * Builds local arrays and assigns once: Vue 2 does not react to
		 * assignment by array index, which the previous version relied on
		 * getting away with because `loaded` flipped straight afterwards.
		 */
		async loadScanCharts () {
			this.chartsLoading = true
			const charts = []
			const errors = []
			for (let i = 0; i < 3; i++) {
				try {
					const { data } = await getScanChart(this.scanGuid, i + 1)
					charts[i] = this.chartData(data)
					errors[i] = null
				} catch (error) {
					charts[i] = null
					errors[i] = error
				}
			}
			this.chartDatas = charts
			this.chartErrors = errors
			this.chartsLoading = false
		},
		chartData (chart) {
			const { chartItems } = chart

			const labels = []
			const datasets = [
				{
					data: [],
					backgroundColor: chartItems.map((item, index) => {
						return chartColors[index]
					})
				}
			]
			chartItems.forEach(({ categoryName, count }) => {
				if (count === 0) {
					return
				}
				labels.push(categoryName)
				datasets[0].data.push(count)
			})
			return {
				labels,
				datasets
			}
		}
	}
}
</script>
